
import { usePermissionStore } from "@/store";
import { defineComponent, ref, toRaw } from "vue";
import { RouteRecordRaw, useRoute, useRouter } from "vue-router";
import MenuItem from "./MenuItem.vue";

const HOME_PAGE_PATH = "/shinsei-list";
export default defineComponent({
  name: "navbar",
  components: {
    MenuItem,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const activeIndex = ref(route.path);

    const handleSelect = (key: string) => {
      activeIndex.value = key;
    };
    const goHome = () => {
      activeIndex.value = HOME_PAGE_PATH;
      router.push(activeIndex.value);
    };

    const allRoutes = toRaw(usePermissionStore().getAllRoutes);
    const showRoutes = (routes: RouteRecordRaw[]) => {
      const res: Array<RouteRecordRaw> = [];
      routes.forEach((route) => {
        const tempRoute: RouteRecordRaw = { ...route };
        if (tempRoute.meta?.showOnMenu) {
          if (tempRoute.children) {
            tempRoute.children = showRoutes(tempRoute.children);
          }
          res.push(tempRoute);
        }
      });
      return res;
    };

    return {
      activeIndex,
      handleSelect,
      showRoutes,
      goHome,
      allRoutes,
    };
  },
});
